import React from 'react'
import { useFileUpload } from './provider'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'

const Container = styled.View`
  padding: 4px 0;
`

export const FileUploadTitle = () => {
  const { title } = useFileUpload()

  return (
    <Container>
      <Typography variant="subheaderBold" color="text">
        {title}
      </Typography>
    </Container>
  )
}
